export const deEnum = (value) => {
  switch (value) {
    case 'Semi_automaat':
      return 'Semi-automaat';
    default:
      return value;
  }
};

export const shorten = (value) => {
  switch (value) {
    case 'Handgeschakeld':
      return 'Schakel';
    case 'Automaat':
    case 'Semi_automaat':
    case 'CVT':
      return 'Autom.';
    default:
      return value;
  }
};

export default null;
